import { useMemo, useRef } from 'react';
import { Grid } from '@mui/material';
import { useGetUpliftAnalyticsQuery } from 'store/api';
import { KpiCard } from '@centerpiece/components';
import { useAnalyticContext } from 'contexts/analytic.context';

export const ProjectUpliftKpiCards = () => {
  const {
    contactRecord,
    team,
    setTeam,
    individual,
    setIndividual,
    projectType,
    setProjectType,
  } = useAnalyticContext();
  const { data: uplift = {}, isFetching: kpiCardsLoading } =
    useGetUpliftAnalyticsQuery({
      params: {
        team: team?.id,
        individual: individual?.id,
        project_type: projectType.id,
      },
    });
  const kpiCards = useMemo(() => {
    return [
      {
        id: 'uplift',
        title: 'Project Uplift %',
        value: uplift.num_uplift_projects / uplift.num_projects,
        num: `${uplift.num_uplift_projects}/${uplift.num_projects}`,
        percent: true,
      },
      {
        id: 'avg_uplift',
        title: 'Average Sales Uplift',
        value: uplift.avg_uplift,
        num: uplift.num_projects,
        percent: true,
      },
      {
        id: 'win_rate',
        title: 'Average Margin Uplift',
        value: uplift.avg_margin_uplift / 100,
        num: uplift.num_projects,
        percent: true,
      },
    ];
  }, [uplift]);

  return (
    <Grid container spacing={2}>
      {kpiCards.map(kpiCard => (
        <Grid key={`kpi-card-${kpiCard.id}`} item xs={6} md={3}>
          <KpiCard
            title={kpiCard.title}
            value={kpiCard?.value || 0}
            loading={kpiCardsLoading}
            caption={`${kpiCard.num || 0} projects`}
            percent={kpiCard.percent}
          />
        </Grid>
      ))}
    </Grid>
  );
};
